
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <App />,
)

/**
 * Mantém a aplicação disponível quando o pesquisador reabre um link já visitado
 * sem internet. Os dados da pesquisa pública continuam sendo armazenados pelo
 * cache local existente; aqui armazenamos apenas a estrutura da aplicação.
 */
const registerOfflineAppShell = () => {
  if (!('serviceWorker' in navigator)) return

  const sendLoadedAssetsToCache = (registration: ServiceWorkerRegistration) => {
    const urls = [
      window.location.origin + '/',
      window.location.href,
      ...performance.getEntriesByType('resource')
        .map((entry) => entry.name)
        .filter((url) => {
          try {
            return new URL(url).origin === window.location.origin
          } catch {
            return false
          }
        }),
    ]

    registration.active?.postMessage({ type: 'DNA_CACHE_URLS', urls })
  }

  navigator.serviceWorker.register('/service-worker.js')
    .then((registration) => {
      sendLoadedAssetsToCache(registration)
      navigator.serviceWorker.ready.then(sendLoadedAssetsToCache)
    })
    .catch((error) => {
      console.warn('Não foi possível preparar o acesso offline:', error)
    })
}

registerOfflineAppShell()
